export function isJSFunction(x) {
  return typeof x === 'object' && x && x.type === 'JSFunction';
}